import qs from 'qs';
import Vue from "vue";

import clubsModule from "./type";
import chatModule from '@chat/module/store/type';
import mixin from '@general/lib/mixin';

import { _type as sidebarType } from '@general/modules/sidebar'
import newGroupMessageReceivedListener from '@chat/lib/listeners/newGroupMessageReceivedListener'
import updateGroupMessageListener from '@chat/lib/listeners/updateGroupMessageListener'
import axios from "axios";

const actions = {
    [clubsModule.actions.setClub]({commit}, payload) {
        if (payload.visible === false) {
            payload.mode = 'view'
            payload.clubId = null
        }
        commit(clubsModule.mutations.setClub, payload)
    },
    [clubsModule.actions.setType]({commit}, type) {
        commit(clubsModule.mutations.setType, type)
    },
    [clubsModule.actions.initFilter]({dispatch}) {
        let typeCached = localStorage.getItem('clubs-type')

        if (typeCached === 'friends') {
            typeCached = 'guide'
        }

        if (typeCached) {
            dispatch(clubsModule.actions.setType, typeCached)
        }
    },
    [clubsModule.actions.clubs.like]({store, commit}, club) {
        if (!club.isLiked) {
            axios.post(`/api/likeEvent`, {eventId: club.id})
                .then(() => {
                    club.isLiked = true;
                    commit(clubsModule.mutations.setLikes, club);
                })
        } else {
            axios.post(`/api/dislikeEvent`, {eventId: club.id})
                .then(() => {
                    club.isLiked = false;
                    commit(clubsModule.mutations.setLikes, club);
                })
        }
    },
    [clubsModule.actions.filter.set](store, { key, value }) {
        // Do not set or handle undefined filter vars
        if (value === undefined) {
            return
        }

        // Do not update name filter at this case
        if (key === 'handle' && !!value && value.length > 0 && value.length < 3) {
            return
        }

        store.commit(clubsModule.mutations.filter.set, { key, value })
    },
    [clubsModule.actions.clubs.report](store, data) {
        axios.post('/api/reportEvent', data)
            .then(response => {
                data.callback(response)
            })
    },
    async [clubsModule.actions.clubs.load]({state, commit}) {

        // Cancel previous request
        if (!!app.clubsListCancelSource) {
            if (false === window.pageLoaded) {
                return;
            }

            app.clubsListCancelSource.cancel()
            app.clubsListCancelSource = null
        }
        let payload = {
            type: state.type,
            handle: state.clubs_filter.handle
        }

        payload.page  = state.page + 1
        payload.limit = window.LOAD_CLUBS_DATES_PER_PAGE
        if(localStorage.getItem('location')){
            payload.location = JSON.parse(localStorage.getItem('location'));
        }

        let CancelToken = axios.CancelToken
        app.clubsListCancelSource = CancelToken.source()
        try {
            let response = await axios.post('/api/eventsAround', payload,{
                cancelToken: app.clubsListCancelSource.token
            })
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return true
                }

                // Add dates
                commit(clubsModule.mutations.clubs.add, data)
                commit(clubsModule.mutations.clubs.setPageNum, payload.page)

                return data.discover && data.discover.length > 10 ? false : true
            }
        } catch (error) {
            console.log(error)
            return 'error';
        }

        return true
    },
    async [clubsModule.actions.clubs.loadMembers]({dispatch, state, commit}, club) {
        if(typeof state.members_page == 'undefined'){
            commit(clubsModule.mutations.clubs.setPageMembersNum, 0)
        }
        let payload = {
            page: state.members_page + 1,
            limit: 100
        }
        let location = JSON.parse(localStorage.getItem('location'));
        if(location){
            payload.location = location;
        }

        try {
            let response = await axios.get('/api/event/load-members/'+club.id, {params: payload})
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return true
                }
                $.each(['members','invitedMembers'],function (key,val){
                    if(typeof club[val] == 'undefined'){
                        Vue.set(club, val, []);
                    }
                    Vue.set(club, val, club[val].concat(data[val]));
                })
                dispatch(clubsModule.actions.clubs.update, club)
                commit(clubsModule.mutations.clubs.setPageMembersNum, payload.page)
                return data && (data.members.length === club.members_count ||
                !data.members.length);
            }
        } catch (error) {
            console.error(error)
        }

        return true
    },
    async [clubsModule.actions.clubs.loadMore]({state, commit, getters}, { date, index }) {
        // let payload = {
        //     type: state.type
        // }

        // let existedDateIndex = state.clubDates.findIndex(v => v.date === date)
        // if (existedDateIndex === -1)
        //     return

        // let existedEntry = state.clubDates[existedDateIndex]
        // if (!existedEntry.clubs_range_high_count) {
        //     return
        // }

        // payload.page = existedEntry.page || 0
        // payload.date = date
        // payload.limit = window.LOAD_CLUBS_PER_DATE_NEXT
        // payload.except = getters[clubsModule.getters.clubIdsByDate](date)

        // try {
        //     // Show preloader
        //     commit(clubsModule.mutations.setLoading, true)

        //     let response = await axios.post('/api/eventsAround', payload)
        //     if (response.status === 200) {
        //         let data = response.data
        //         if (!data) {
        //             return 0
        //         }

        //         // Hide preloader
        //         commit(clubsModule.mutations.setLoading, false)

        //         // Add clubs to list
        //         commit(clubsModule.mutations.clubs.add, data)
        //         commit(clubsModule.mutations.clubs.setPageNum, payload.page + 1)
        //     }
        // } catch (error) {
        //     console.error(error)
        // }
    },
    async [clubsModule.actions.clubs.loadInfo](context, payload) {
        let CancelToken = axios.CancelToken
        app.ClubInfoCancelSource = CancelToken.source()
        try {
            const location = localStorage.getItem('location');
            let response = await axios.get(`/api/eventInfo/${payload.clubId}/${payload.edit}?location=`+location,
                {
                    cancelToken: app.ClubInfoCancelSource.token
                })
            if (response.status === 200) {
                if(payload.dont_reset_members && context.rootState.clubsInfo[payload.clubId]){
                  response.data['members'] = context.rootState.clubsInfo[payload.clubId]['members']
                }
                store.commit(clubsModule.mutations.clubs.update, {
                  clubId:   payload.clubId,
                  clubData: response.data
                })
                Vue.set(context.rootState.clubsInfo, payload.clubId, response.data)
                return response.data
            }
        } catch (error) {
            console.error(error)
        }
        return null
    },
    async [clubsModule.actions.clubs.submit]({ dispatch, commit }, data) {
        console.log('[Club Submit] Payload]', { data })

        let updatePerformed = data.id
        let params = []
        if (updatePerformed) {
            params = [
                `/api/updateEvent/${data.id}`,
                Object.assign(data, {type: 'club'}),
                {'Content-Type': 'application/json'}
            ]
        } else {
            params = [
                '/api/createEvent',
                qs.stringify(Object.assign(data, {type: 'club'})),
                {'Content-Type': 'application/x-www-form-urlencoded'}
            ]
        }

        let clubData = null
        return new Promise((resolve,reject) => {
            axios.post(...params).then((response) => {
                clubData = response.data
                console.log('[Submit Club] Response', { response })

                dispatch(clubsModule.actions.setType, 'my_clubs')

                // Created
                if (!updatePerformed) {
                    mixin.methods.showSuccessNotification('club_successfully_added')
                    //not existed
                    //commit('addMyClubs', [clubData.general])

                    if (app.isDesktop) {
                        dispatch(clubsModule.actions.setClub, { visible: false })

                        setTimeout(function(){
                            app.$emit('reload-clubs')
                        }, 750)
                    } else {
                        dispatch(sidebarType.actions.hide)
                        app.goTo('/clubs')
                    }

                    // Listen to new club channel
                    dispatch(clubsModule.actions.membership.addMy, clubData.id)
                } else {
                    dispatch(clubsModule.actions.clubs.update, clubData)

                    if (app.isDesktop) {
                        dispatch(clubsModule.actions.setClub, { visible: false })

                        setTimeout(function(){
                            app.$emit('reload-clubs')
                        }, 750)
                    } else {
                        app.goTo(`/club/${clubData.id}`)
                    }
                }

                resolve('Ok')
            }).catch( (error) => {
                if(error.status === 422) {
                    mixin.methods.showErrorNotification(error.data.error)
                }

                reject('Error')
            });
        });
    },
    async [clubsModule.actions.clubs.remove]({ dispatch, commit }, clubId) {
        dispatch('showDialog', {
            mode: 'confirm',
            message: app.trans('sure_delete_club'),
            callback: async () => {
                console.log('[Delete Club] Callback')
                let response = await axios.post(`/api/removeEvent/${clubId}`)
                if (response.status === 200) {
                    dispatch(clubsModule.actions.clubs.cleanUp, {
                        clubId,
                        removeFromClubList: true
                    })
                }
            }
        })
    },
    [clubsModule.actions.clubs.cleanUp]({ dispatch, commit }, { clubId, removeFromClubList }) {
        if (removeFromClubList) {
            // Remove club from clubs list
            commit(clubsModule.mutations.clubs.remove, clubId)
        }

        // Remove conversation
        dispatch(chatModule.actions.conversations.remove, {eventId: clubId})
        // Remove my membership
        dispatch(clubsModule.actions.membership.removeMy, clubId)

        if (app.isDesktop) {
            // Close club modal
            //dispatch(clubsModule.actions.setBang, { visible: false }) //commented coz this action not exists
            dispatch(clubsModule.actions.setClub, { visible: false })

            // Close club chat
            let clubModal = store.state.chatModule.modal
            if (
                clubModal.club
                &&
                clubModal.club.id == clubId
            ) {
                store.commit(chatModule.mutations.modal, {
                    club: null,
                    user: null,
                    mode: null,
                    minimized: false
                })
            }
        } else if (app.isMobile) {
            let routeClubId = app.$route.params && app.$route.params.clubId

            // Exit club chat
            if (['chat-group', 'chat-club-user'].includes(app.$route.name)) {
                app.goTo('/chat')

            // Exit club
            } else if (
                ['edit-club', 'club'].includes(app.$route.name)
                &&
                routeClubId == clubId
            ) {
                app.goTo('/clubs')
            }
        }
    },
    [clubsModule.actions.resetPagination]({ commit }) {
        commit(clubsModule.mutations.resetPagination)
    },
    [clubsModule.actions.clubs.updateMembers]({ dispatch, commit, rootState },{club_id,members}){
        if (
            club_id
            &&
            rootState.clubsInfo[club_id]
        ) {
            Vue.set(
                rootState.clubsInfo[club_id],
                'members',
                members
            )
        }
    },
    [clubsModule.actions.clubs.updateInvitedMembers]({ dispatch, commit, rootState },{club_id,members}){
        if (
            club_id
            &&
            rootState.clubsInfo[club_id]
        ) {
            Vue.set(
                rootState.clubsInfo[club_id],
                'invitedMembers',
                members
            )
        }
    },
    [clubsModule.actions.clubs.update]({ dispatch, commit, rootState }, general) {
        if (general.id) {
            // Chat list
            dispatch(chatModule.actions.conversations.updateConversationEvent, {
                eventId: general.id,
                eventData: general
            })
        }

        if (general.id) {
            // Clubs list
            commit(clubsModule.mutations.clubs.update, {
                clubId:   general.id,
                clubData: general
            })
        }

        // Clubs cached info
        if (
          general.id
            &&
            rootState.clubsInfo[general.id]
        ) {
            Vue.set(
                rootState.clubsInfo,
              general.id,
                {...rootState.clubsInfo[general.id], ...general}
            )
        }
    },
    async [clubsModule.actions.membership.request](store, {clubId, userId, action}) {
        let response = await axios.post('/api/eventMembership', {
            eventId: parseInt(clubId),
            userId,
            action
        })

        if (response.status === 200) {
            if (action === 'leave') {
                // Clean up
                store.dispatch(clubsModule.actions.clubs.cleanUp, {
                    clubId: parseInt(clubId),
                    removeFromClubList: false
                })

                if(!(app.isMobile && app.$router.history.current.name === 'chat')){
                    app.goTo('/clubs')
                }
            }
        }
         
    },
    [clubsModule.actions.membership.set](store, payload) {
        payload.forEach(id => {
            store.dispatch(clubsModule.actions.membership.add, id)
        })
    },
    [clubsModule.actions.membership.setMy](store, payload) {
        payload.forEach(id => {
            store.dispatch(clubsModule.actions.membership.addMy, id)
        })
    },
    [clubsModule.actions.membership.add](store, clubId) {
        store.commit(clubsModule.mutations.membership.add, clubId)
    },
    [clubsModule.actions.membership.remove](store, clubId) {
        store.commit(clubsModule.mutations.membership.remove, clubId)
    },
    [clubsModule.actions.membership.addMy](store, clubId) {
        store.commit(clubsModule.mutations.membership.addMy, clubId)
        store.dispatch(clubsModule.actions.membership.subscribe, clubId)
    },
    [clubsModule.actions.membership.removeMy](store, clubId) {
        store.commit(clubsModule.mutations.membership.removeMy, clubId)
        store.dispatch(clubsModule.actions.membership.unsubscribe, clubId)
    },
    [clubsModule.actions.membership.subscribe](store, clubId) {
        if (window.Echo) {
            console.log('[Echo] Listening to channel-group-chat-' + clubId)
            window.Echo.private('channel-group-chat-' + clubId)
                .listen('NewGroupMessageReceived', newGroupMessageReceivedListener)
                .listen('UpdateGroupMessage', updateGroupMessageListener)
        } else {
            console.log('[Echo] No Echo. Cannot listen to channel-group-chat-' + clubId)
        }
    },
    [clubsModule.actions.membership.unsubscribe](store, clubId) {
        if (window.Echo) {
            console.log('[Echo] Leaving channel-group-chat-' + clubId)
            window.Echo.leave('channel-group-chat-' + clubId)
        } else {
            console.log('[Echo] No Echo. Cannot unsubscribe from channel-group-chat-' + clubId)
        }
    },
    [clubsModule.actions.membership.unsubscribeFromAll](store) {
        let memberships = store.state.myMemberships
        for (let clubId in memberships) {
            store.dispatch(clubsModule.actions.membership.unsubscribe, clubId)
        }
    }
}

export default actions
